import { FC } from 'react';
import { DialogInner } from 'shared/components/DialogInner';
import { Button } from 'shared/components/ui/Button';
import { TNetworkError } from 'shared/exceptions/network';

type TProps = {
  onClose?: () => void;
  message?: string;
  gameId?: string;
  error?: TNetworkError;
};

export const ErrorGameDialog: FC<TProps> = props => {
  const { onClose, message, gameId, error } = props;
  return (
    <DialogInner>
      <div className="dialog__content">
        <div className="dialog__logo">
          <img src="/images/userpic_splittest.png" alt="" />
        </div>
        <h3 className="dialog__title">SplitTestGames</h3>
        {!!gameId && <p className="dialog__text">{`Игра #${gameId}`}</p>}
        <p className="dialog__text">
          {!!message ? message : 'Возникла ошибка приложения'}
        </p>
        {/* {!!error && <pre>{JSON.stringify(error)}</pre>} */}
      </div>
      <div className="dialog__buttons">
        <Button
          className="dialog__button--close"
          variant="dialog"
          onClick={onClose}
        >
          Закрыть
        </Button>
      </div>
    </DialogInner>
  );
};
